<template>
  <v-row>

    <template v-if="!loading">
      <v-col 
        v-if="!user_profile.roles.some(role => role.name === 'participant')"
        cols="12">
        <v-sheet
          width="100%"
          outlined >
          <v-row class="ma-1">
            <v-col
              cols="12"
              xl="4"
              md="4"
              sm="12"
            >
              <v-text-field
                outlinedd
                v-model="name"
                :counter="50"
                label="Nombre completo"
                required
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
              xl="4"
              md="4"
              sm="12"
            >
              <v-text-field
                outlinedd
                v-model="lastname"
                :counter="50"
                label="Apellido"
                required
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
              xl="4"
              md="4"
              sm="12"
            >
              <v-text-field
                outlinedd
                v-model="email"
                :counter="100"
                :rules="emailRules"
                label="Correo electrónico"
                required
                disabled
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
            >
              <h3 class="body-1">Mis Roles:</h3>
            </v-col>
  
            <v-col
              cols="12"
            >
              <v-chip 
                v-for="role in user_profile.roles"
                v-bind:key="role.id"
                class="mr-2 ml-2"
                color="#0097B4"
                dark
              >
                <label v-if="role.name==='admin'">
                  Administrador
                </label>
  
                <label v-if="role.name==='organizer'">
                  Organizador
                </label>
  
                <label v-if="role.name==='entrepreneur'">
                  Emprendedor
                </label>
  
                <label v-if="role.name==='evaluator'">
                  Evaluador
                </label>
  
                <label v-if="role.name==='participant'">
                  Participante
                </label>
              </v-chip>
            </v-col>
  
            <v-col cols="12">
              <v-switch
                v-model="change_password"
                label="Cambiar contraseña"
              ></v-switch>
            </v-col>
  
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlinedd
                type="password"
                :disabled="!change_password"
                v-model="password"
                :counter="50"
                label="Contraseña"
                required
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlinedd
                type="password"
                :disabled="!change_password"
                v-model="confirm_password"
                :counter="50"
                label="Confirmar contraseña"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
  
      <v-col 
        cols="12"
        v-if="user_profile.roles.some(role => role.name === 'participant')">
        <v-sheet
          width="100%"
          outlined >
          <v-row class="ma-1">
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlined
                v-model="name"
                :counter="50"
                label="Nombre completo"
                required
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlined
                v-model="lastname"
                :counter="50"
                label="Apellido"
                required
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlined
                v-model="email"
                :counter="100"
                :rules="emailRules"
                label="Correo electrónico"
                required
                disabled
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="DNI/Pasaporte/Cédula"
                type="text"
                :counter="50"
                :maxlength="50"
                v-model="dni"
                >
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-select
                outlined
                v-model="gender_id"
                :items="genders"
                item-value="id"
                item-text="name"
                label="Género"
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-select
                outlined
                :items="countries"
                v-model="country_id"
                item-text="name"
                item-value="id"
                label="Pais*"
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id==argentina_id">
              <v-select
                outlined
                :items="provincias"
                v-model="provincia_id"
                v-on:change="getLocalidades()"
                item-text="name"
                item-value="id"
                label="Provincia*"
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id!=argentina_id">
              <v-text-field
                outlined
                :maxlength="70"
                :counter="70"
                :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
                ref="other_provincia"
                v-model="other_provincia"
                label="Estado/provincia"
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id==argentina_id">
              <v-select
                outlined
                :items="localidades"
                v-model="localidad_id"
                item-text="name"
                item-value="id"
                label="Localidad*"
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id!=argentina_id">
              <v-text-field
                outlined
                :maxlength="70"
                :counter="70"
                :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
                ref="other_localidad"
                v-model="other_localidad"
                label="Localidad"
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Carrera o profesión"
                type="text"
                :counter="50"
                :maxlength="50"
                v-model="career">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-select 
                outlined
                v-model="institution_you_are_part"
                :items="institution_you_are_part_options"
                label="Empresa o institución de la que sos parte"
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Institución de la que proviene"
                type="text"
                :counter="70"
                :maxlength="70"
                v-model="institution">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Si tenés un emprendimiento, contanos cómo se llama"
                type="text"
                :counter="70"
                :maxlength="70"
                v-model="entrepreneurship_name">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Teléfono movil (+cod país + cód área + número)"
                type="text"
                :counter="50"
                :maxlength="50"
                v-model="phone_number"
                placeholder="CÓDIGO PAÍS + CÓDIGO ÁREA + NÚMERO DE CELULAR">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Linkedin"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="linkedin"
                placeholder="https://www.linkedin.com/in/universidad-nacional-del-litoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Facebook"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="facebook"
                placeholder="https://www.facebook.com/UNLitoralAr/">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="YouTube"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="youtube"
                placeholder="https://youtube.com/vinculacionunl">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Twitter"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="twitter"
                placeholder="https://twitter.com/UNLitoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Instagram"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="instagram"
                placeholder="https://www.instagram.com/unlitoral_/">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Telegram"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="telegram"
                placeholder="https://t.me/unlitoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Discord"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="discord"
                placeholder="https://www.discord.com/unlitoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Twitch"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="twitch"
                placeholder="https://www.twitch.tv/unlitoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="TikTok"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="tiktok"
                placeholder="https://www.tiktok.com/@unlitoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                outlined
                label="Snapchat"
                type="text"
                :counter="100"
                :maxlength="100"
                v-model="snapchat"
                placeholder="https://www.snapchat.com/profile/unlitoral">
              </v-text-field>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-select
                outlined
                v-model="communication_channel_id"
                :items="communication_channels"
                item-text="name"
                item-value="id"
                label="¿Cómo te enteraste de la actividad?"
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-select
                outlined
                v-model="completed_studies"
                :items="completed_studies_options"
                label="Máximo nivel de estudios que alcanzaste."
              ></v-select>
            </v-col>
  
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-select
                outlined
                v-model="receive_information"
                :items="receive_information_options"
                label="¿Querés recibir información de JIJE y otras novedades en tu celular?"
              ></v-select>
            </v-col>
  
            <v-col
              cols="12"
            >
              <h3 class="body-1">Mis Roles:</h3>
            </v-col>
  
            <v-col
              cols="12"
            >
              <v-chip 
                v-for="role in user_profile.roles"
                v-bind:key="role.id"
                class="mr-2 ml-2"
                color="#0097B4"
                dark
              >
                <label v-if="role.name==='admin'">
                  Administrador
                </label>
  
                <label v-if="role.name==='organizer'">
                  Organizador
                </label>
  
                <label v-if="role.name==='entrepreneur'">
                  Emprendedor
                </label>
  
                <label v-if="role.name==='evaluator'">
                  Evaluador
                </label>
  
                <label v-if="role.name==='participant'">
                  Participante
                </label>
              </v-chip>
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="change_password"
                label="Cambiar contraseña"
              ></v-switch>
            </v-col>
  
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlined
                type="password"
                :disabled="!change_password"
                v-model="password"
                :counter="50"
                label="Contraseña"
                required
              ></v-text-field>
            </v-col>
  
            <v-col
              cols="12"
              xl="6"
              md="6"
              sm="12"
            >
              <v-text-field
                outlined
                type="password"
                :disabled="!change_password"
                v-model="confirm_password"
                :counter="50"
                label="Confirmar contraseña"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </template>

    <v-col cols="12" class="pt-8 d-flex justify-space-between">
      <v-btn
        depressed
        color="#0097B4"
        dark
        :to="{ name: 'home'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="#0097B4"
        dark
        @click="updateProfile"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando información...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_error"
      width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Advertencia</span>
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <v-list-item-content>

              <v-list-item-title
                v-for="error in errors" v-bind:key="error">
                  {{ error }}
              </v-list-item-title>

            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary darken-1"
            text
            @click="dialog_error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Profile',

    data: () => ({
      loading:true,
      loading_update:false,
      show:false,
      
      dialog_error: false,

      valid:null,

      name:'',
      lastname:'',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 50 || 'Name must be less than 10 characters',
      ],

      dni:null,

      gender_id: null,
      genders:[],

      argentina_id: null, 
      country_id: null,
      countries: [],

      other_provincia:null,
      provincia_id: null,
      provincias:[],

      other_localidad:null,
      localidad_id_first:true,
      localidad_id: null,
      localidades:[],

      participant_type: 'Asistente',
      participant_type_options: [    
        'Asistente',
        'Expositor',
        'Organizador'
      ],

      institution:null,
      career:null,

      institution_you_are_part: 'Foro de Capital',
      institution_you_are_part_options: [
        'Foro de Capital',
        'Estudiante de grado UNL',
        'Incubados IDEAR',
        'Incubados Expresiva',
        'Incubados PTLC',
        'Gabinetes para Emprendedores UNL',
        'Proyectos UNL BIO',
        'Docentes de Cátedras Electivas de Emprendedores UNL',
        'UTID',
        'Otra'
      ],

      entrepreneurship_name:null,
      phone_number:null,
      whatsapp:null,
      telegram:null,
      linkedin:null,
      facebook:null,
      youtube:null,
      twitter:null,
      instagram:null,
      discord:null,
      twitch:null,
      tiktok:null,
      snapchat:null,

      communication_channel_id:null,
      communication_channels:[],

      completed_studies: 'Secundario incompleto',
      completed_studies_options:[
        'Secundario incompleto',
        'Secundario completo',
        'Terciario incompleto',
        'Terciario completo',
        'Universitario incompleto',
        'Universitario completo',
        'Posgrado incompleto',
        'Posgrado completo',
        'Otro'
      ],

      receive_information: 'Si',
      receive_information_options:[
        'Si', 'No'
      ],

      email: '',
      emailRules: [
        v => !!v || 'Correo electrónico es requerido',
        v => /.+@.+/.test(v) || 'Correo electrónico debe ser valido',
      ],

      change_password: false,
      password:'',
      confirm_password:'',

      user_profile:[],
      errors: [],

      data: null
    }),
    computed: {
    ...mapGetters([
      'user'
    ])
  },

  methods:{

    async getCountries(){
      try {
        await axios.get('countries').then(response =>{
          this.countries = response.data.data.countries
          if(this.countries.length>0){
            this.countries.forEach(element=>{
              if(element.name=='Argentina'){
                this.argentina_id=element.id
                this.country_id=element.id
                this.provincia_id = 22
              }
            })
          }
            
        }).catch(error => {
          console.log(error);
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getProvincias(){
      try {
        await axios.get('provincias').then(response =>{
          this.provincias = response.data.provincias
        }).catch(error => {
          console.log(error);
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getLocalidades(){
      try {
        await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
          this.localidades = response.data.provincia.localidads

          this.localidad_id_first = true

          if(this.localidad_id_first){
            this.localidad_id = this.localidades[0].id
          }
          this.localidad_id_first = false
        }).catch(error => {
          console.log(error);
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getLocalidadesLoad(){
      try {
        await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
          this.localidades = response.data.provincia.localidads
        }).catch(error => {
          console.log(error);
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getChannelsComunication(){
      try {
        await axios.get('comunication-channels').then(response =>{
          this.communication_channels = response.data.data.comunication_channels
          if(this.communication_channels.length>0){
            this.communication_channel_id = this.communication_channels[0].id
          }
          this.loading=false
        }).catch(error => {
          console.log(error)
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getGenders(){
      try {
        await axios.get('genders').then(response =>{
          if(response.data.length!==0){
            this.genders = response.data.genders

            if(!this.gender_id){
              if(this.genders.length>0){
                this.gender_id = this.genders[0].id
              }
            }
          }
        }).catch(error => {
          console.log(error);
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getUser()
    {
      this.data = JSON.parse(localStorage.getItem('user'))
      await axios.get('user').then(response =>{
        this.user_profile = response.data.user

        this.name = response.data.user.name
        this.lastname = response.data.user.lastname
        this.email = response.data.user.email

        if(this.user_profile.participant_profile){
          this.dni = this.user_profile.participant_profile[0].dni
          this.gender_id = this.user_profile.participant_profile[0].gender_id
          this.country_id = this.user_profile.participant_profile[0].country_id
          this.other_provincia = this.user_profile.participant_profile[0].other_provincia
          this.provincia_id = this.user_profile.participant_profile[0].provincia_id
          this.other_localidad = this.user_profile.participant_profile[0].other_localidad
          this.localidad_id = this.user_profile.participant_profile[0].localidad_id
          this.participant_type = this.user_profile.participant_profile[0].participant_type
          this.institution = this.user_profile.participant_profile[0].institution
          this.career = this.user_profile.participant_profile[0].career
          this.institution_you_are_part = this.user_profile.participant_profile[0].institution_you_are_part
          this.entrepreneurship_name = this.user_profile.participant_profile[0].entrepreneurship_name
          this.phone_number = this.user_profile.participant_profile[0].phone_number
          this.whatsapp = this.user_profile.participant_profile[0].whatsapp
          this.telegram = this.user_profile.participant_profile[0].telegram
          this.linkedin = this.user_profile.participant_profile[0].linkedin
          this.facebook = this.user_profile.participant_profile[0].facebook
          this.youtube = this.user_profile.participant_profile[0].youtube
          this.twitter = this.user_profile.participant_profile[0].twitter
          this.instagram = this.user_profile.participant_profile[0].instagram
          this.discord = this.user_profile.participant_profile[0].discord
          this.twitch = this.user_profile.participant_profile[0].twitch
          this.tiktok = this.user_profile.participant_profile[0].tiktok
          this.snapchat = this.user_profile.participant_profile[0].snapchat
          this.communication_channel_id = this.user_profile.participant_profile[0].communication_channel_id
          this.completed_studies = this.user_profile.participant_profile[0].completed_studies
          this.receive_information = this.user_profile.participant_profile[0].receive_information
        }

        this.getLocalidadesLoad()
        this.loading=false
        this.show=true
      }).catch(error => {
        console.log(error);
      })
    },

    async updateProfile()
    {
      this.user.name = this.name

      this.loading_update = true
      this.errors=[]
      try {
        await axios.put('user/'+this.user.id,{
          name: this.name, 
          lastname: this.lastname,
          email: this.email,

          dni: this.dni, 
          gender_id: this.gender_id, 
          country_id: this.country_id, 
          other_provincia: this.other_provincia, 
          provincia_id: this.provincia_id, 
          other_localidad: this.other_localidad, 
          localidad_id: this.localidad_id, 
          participant_type: this.participant_type, 
          institution: this.institution, 
          career: this.career, 
          institution_you_are_part: this.institution_you_are_part, 
          entrepreneurship_name: this.entrepreneurship_name, 
          phone_number: this.phone_number, 
          whatsapp: this.whatsapp, 
          telegram: this.telegram, 
          linkedin: this.linkedin, 
          facebook: this.facebook, 
          youtube: this.youtube, 
          twitter: this.twitter, 
          instagram: this.instagram, 
          discord: this.discord, 
          twitch: this.twitch, 
          tiktok: this.tiktok, 
          snapchat: this.snapchat, 
          communication_channel_id: this.communication_channel_id, 
          completed_studies: this.completed_studies, 
          receive_information: this.receive_information,

          change_password: this.change_password,
          password: this.password,
          confirm_password: this.confirm_password
        }).then(() =>{
          this.$router.push({ name: 'CheckConvocations' })  
        })
      }catch (error) {
        console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")

        if( error.response.data.errors.length != 0){
          Object.values(error.response.data.errors).forEach(error => {
            this.errors.push(error[0])
          })
        }
        this.password = ''
        this.confirm_password = ''
        this.loading_update=false
        this.dialog_error = true
      }
    }
  },

  created(){

    Promise.all([

      window.scrollTo(0,0),

      this.getChannelsComunication(),
      this.getCountries(),
      this.getProvincias(),
      this.getGenders()
    ]).then(() => {
      this.getUser()
    }).catch((error) => {
      console.log(error)
    });
  },
}
</script>
